import angular from 'angular';
import {
  alerts
} from 'app/components/global';
import {
  loaderService,
  ssDialogService,
  bcpDataService
} from 'app/services';
import controller from './edit-facilities-dialog.controller';
import template from './edit-facilities-dialog.html';

import alternateFacilitiesProcedureTextMessagesTpl from './messages/alternate-facilities.procedure-text.messages.html';

class dialogService {
  getOptions($event, {
    // eslint-disable-next-line no-shadow
    assessmentFacilities
  }) {
    return {
      controller,
      controllerAs: 'editFacilitiesDialogVM',
      locals: {
        assessmentFacilities,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editFacilitiesDialog', [
  loaderService,
  ssDialogService,
  bcpDataService,
  alerts,
])
  .service('editFacilitiesDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put(
      'alternate-facilities.procedure-text.messages.html',
      alternateFacilitiesProcedureTextMessagesTpl
    );
  })
  .name;
